import { useEffect, useState } from 'react';

export function useDebounce<T>(value: T, delay = 500, onDebounce?: () => void): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
      onDebounce?.();
    }, delay);

    return () => {
      clearTimeout(timer);
    };
  }, [value, delay, onDebounce]);

  return debouncedValue;
}
